



















import {Component, Vue} from 'vue-property-decorator'
import {Action} from 'vuex-class'
import SurveyModel from '@/classes/SurveyModel'
import {Task} from '@/store/types'

@Component({})
export default class SurveyNoDateList extends Vue {
  @Action('getTaskList') public getTaskList: any

  public pendingSurveys: Task[] = []

  public created() {
    // todo: without includes
    this.getTaskList([`status=${SurveyModel.STATUS.PENDING}`])
      .then((response: Task[]) => this.pendingSurveys = response)
  }
}
